import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import ActiveHeartIcon from "./../../assets/imgs/icons/heart-solid.svg";
import HeartIcon from "./../../assets/imgs/icons/heart.svg";

import ProductDetailCardLoading from "./detail-card-loading";
import UBXButton from "./../ubx/button";

import { ProductRedirect } from "./../../config/products";
import { MAINTENANCE } from "./../../config/feature-flags";

import { properNumber, stringifyNumber } from "./../../helpers/number";
import { generateLocationNotice } from "./../../helpers/product";
import { getStaticText, getPagePath } from "./../../helpers/system";
import { featureEnabled } from "./../../helpers/feature-flags";

import ProductText from "./../../const/product.json";

import DefaultLogo from "./../../assets/imgs/logo-v2.png";

const InvestreeTopOrg = "IN002";
export default class ProductDetailsCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReady: false,
            product: {},
            lenderLogo: {},
        };
    }

    async componentDidMount() {
        await this.initProduct();
    }

    async initProduct() {
        const { product: productProp = {}, productReady } = this.props;

        const {
            id,
            locations,
            name,
            productOrg,
            config = {},
            lenderLogo: lender = false,
            approvalTime,
            interestRate,
            annualPercentageRate,
            processingFee,
        } = productProp;
        const { loan_type: loanType, processing_fee_amount: processingFeeAmount } = config;
        const { logo: lenderLogo = false } = lender;

        const product = {
            id,
            name,
            locations,
            productOrg,
            loanType,
            approvalTime,
            interestRate,
            annualPercentageRate,
            processingFee,
            processingFeeAmount,
        };

        await this.setState({ product, isReady: productReady, lenderLogo });
    }

    onProductAction(e) {
        const { onProductAction = false } = this.props;

        if (onProductAction) {
            onProductAction(e);
        }
    }

    renderLogo() {
        const {
            product: { loanType, name },
            lenderLogo = {},
        } = this.state;

        let loanTypeText;
        let customClass;

        if (loanType) {
            if (loanType === "term_loan") {
                loanTypeText = "business loan";
            } else {
                loanTypeText = loanType.replace(/_/g, " ");
            }
            customClass = loanType.replace(/_/g, "-");
        }

        return (
            <span className="logo">
                <img
                    loading="lazy"
                    src={lenderLogo || DefaultLogo}
                    alt={`${name || "Lender"} Logo`}
                    width="auto"
                    height="40"
                />
                <p className={customClass}>{loanTypeText}</p>
            </span>
        );
    }

    renderName() {
        const {
            product: { name },
        } = this.state;

        return name ? <h2 className="product-name">{name}</h2> : null;
    }

    renderNotice() {
        const {
            product: { productOrg },
        } = this.state;

        return (
            <h4>
                {getStaticText(ProductText, ["productNotice1", productOrg])}{" "}
                <span>{getStaticText(ProductText, ["productNotice2", productOrg])}</span>
            </h4>
        );
    }

    renderAmortization() {
        const { loanAmortization } = this.props;

        return (
            <h3>
                {getStaticText(ProductText, "prefixAmortization")}&nbsp;
                {loanAmortization ? stringifyNumber(loanAmortization, 2) : "------"}
                {getStaticText(ProductText, "suffixAmortization")}
            </h3>
        );
    }

    renderFinancingAmount() {
        const { loanAmortization, loanTerm } = this.props;
        const totalLoanAmount = loanAmortization * loanTerm;

        return (
            <>
                <h3>
                    {getStaticText(ProductText, "prefixFinancingAmount")}
                    {totalLoanAmount ? properNumber(totalLoanAmount, 2) : "------"}
                </h3>
                <span>{getStaticText(ProductText, "labelFinancingAmount")}</span>
            </>
        );
    }

    renderLocationNotice() {
        const {
            product: { locations },
        } = this.state;

        const notice = generateLocationNotice(locations);

        return notice ? <p className="notice">{"*" + notice}</p> : <br />;
    }

    renderProcessingFee() {
        const { product } = this.state;
        const { processingFee: feeRate = 0, processingFeeAmount: feeAmount = 0 } = product;

        if (!feeAmount) {
            return (
                <>
                    {feeRate}
                    {getStaticText(ProductText, "suffixProcessingFee")}
                </>
            );
        }

        if (!feeRate) {
            return (
                <>
                    {getStaticText(ProductText, "prefixProcessingFee")}
                    {properNumber(feeAmount, 2)}
                </>
            );
        }

        return (
            <>
                {feeRate}
                {getStaticText(ProductText, "suffixProcessingFee")} <small>or</small>{" "}
                {getStaticText(ProductText, "prefixProcessingFee")}
                {feeAmount} <small>whichever is higher</small>
            </>
        );
    }

    renderDetails() {
        const { loanTerm, loanAmount } = this.props;
        const { product } = this.state;
        const { productOrg, interestRate, annualPercentageRate, approvalTime } = product;

        const annualInterestRate = annualPercentageRate ?? interestRate * 12;
        const totalRepayment = parseFloat(loanAmount) + (interestRate / 100) * loanTerm * parseFloat(loanAmount);

        return (
            <Fragment>
                {productOrg !== InvestreeTopOrg && (
                    <div className="detail-item">
                        <div className="label">{getStaticText(ProductText, ["labelTotal", productOrg])}</div>
                        <div className="value">
                            {getStaticText(ProductText, "prefixTotal")}
                            {loanAmount ? properNumber(loanAmount, 2) : "------"}
                        </div>
                    </div>
                )}
                <div className="detail-item">
                    <div className="label">{getStaticText(ProductText, "labelTenor")}</div>
                    <div className="value">
                        {loanTerm ? loanTerm : "--"} {loanTerm > 1 ? "Months" : "Month"}
                    </div>
                </div>
                <div className="detail-item">
                    <div className="label">{getStaticText(ProductText, "labelApprovalTime")}</div>
                    <div className="value">{`${approvalTime} ${approvalTime > 1 ? "Days" : "Day"}`}</div>
                </div>
                <div className="detail-item">
                    <div className="label">{getStaticText(ProductText, ["labelInterestRate", productOrg])}</div>
                    <div className="value">
                        {interestRate}
                        {getStaticText(ProductText, "suffixInterestRate")}
                    </div>
                </div>
                <div className="detail-item">
                    <div className="label">{getStaticText(ProductText, ["labelAnnualInterestRate", productOrg])}</div>
                    <div className="value">
                        {annualInterestRate}
                        {getStaticText(ProductText, "suffixAnnualInterestRate")}
                    </div>
                </div>
                <div className="detail-item">
                    <div className="label text-left">{getStaticText(ProductText, "labelProcessingFee")}</div>
                    <div className="value">{this.renderProcessingFee()}</div>
                </div>
                {productOrg !== InvestreeTopOrg && (
                    <div className="detail-item">
                        <div className="label">{getStaticText(ProductText, "labelTotalRepayment")}</div>
                        <div className="value">
                            {getStaticText(ProductText, "prefixTotalRepayment")}
                            {totalRepayment ? properNumber(totalRepayment, 2) : "------"}
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }

    renderButton() {
        const { userLoggedIn, loanTerm, loanAmount } = this.props;
        const {
            product: { loanType, productOrg },
        } = this.state;

        let customClass;

        if (loanType) {
            customClass = loanType.replace(/_/g, "-");
        }

        let buttonText = "";
        let loginLink = "";
        if (ProductRedirect[productOrg]) {
            const { text } = ProductRedirect[productOrg];

            buttonText = text;
        } else {
            buttonText = userLoggedIn
                ? getStaticText(ProductText, "applyUser")
                : getStaticText(ProductText, "applyNonUserAlt");

            if (!userLoggedIn) {
                loginLink = (
                    <Fragment key="frag">
                        <p>
                            Don’t have an account yet? <Link to={getPagePath("UserSignUp")}>Sign Up</Link>
                        </p>
                    </Fragment>
                );
            }
        }

        const productReady = loanTerm && loanAmount ? true : false;

        let buttonEnabled = false;
        if (userLoggedIn) {
            buttonEnabled = productReady ? true : false;
            if (featureEnabled(MAINTENANCE)) {
                buttonEnabled = false;
            }
        } else {
            buttonEnabled = true;
        }

        return [
            <UBXButton
                key="product-action"
                id="product-action"
                type="primary"
                className={customClass}
                block={true}
                onClick={(e) => this.onProductAction(e)}
                disabled={!buttonEnabled}
            >
                {buttonText}
            </UBXButton>,
            loginLink,
        ];
    }

    renderWishlistButton() {
        const {
            openWishlistModal,
            handleAddToWishlist,
            wishlistAdded,
            userLoggedIn,
            wishlistReady = false,
            loanTerm,
            loanAmount,
        } = this.props;

        if (userLoggedIn && wishlistReady) {
            const productReady = loanTerm && loanAmount ? true : false;

            return (
                <div className="product-actions">
                    {wishlistAdded ? (
                        <span onClick={(e) => openWishlistModal(e)}>
                            <img src={ActiveHeartIcon} alt="heart icon" className="mr-1" />
                            Saved
                        </span>
                    ) : (
                        <span onClick={(e) => handleAddToWishlist(e)} disabled={!productReady}>
                            <img src={HeartIcon} alt="heart icon" className="mr-1" />
                            Save this loan product
                        </span>
                    )}
                </div>
            );
        }
    }

    render() {
        const {
            isReady,
            product: { productOrg },
        } = this.state;

        const customClassNames = ["product-details"];

        return isReady ? (
            <div className={customClassNames.join(" ")}>
                {this.renderLogo()}
                {this.renderName()}
                {this.renderNotice()}
                {productOrg !== InvestreeTopOrg ? this.renderAmortization() : this.renderFinancingAmount()}
                {this.renderLocationNotice()}
                {this.renderDetails()}
                <hr />
                {this.renderButton()}
                {this.renderWishlistButton()}
            </div>
        ) : (
            <ProductDetailCardLoading />
        );
    }
}
